import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const danishWeekdays = ['man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.', 'søn.'];
const danishMonths = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getWeekdayLabel(weekday: number, _width?: TranslationWidth): string {
        return danishWeekdays[weekday - 1];
    }

    getMonthShortName(month: number): string {
        return danishMonths[month - 1];
    }

    getMonthFullName(month: number): string {
        return this.getMonthShortName(month);
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`;
    }
}
